/* Az alkotóelemek: lean by real order, staggered reveal, fade out on leaving, and the
   "Bővebben" close (fade the floating text out first, then close, so the card never
   stretches). One observer per section, everything torn down on unload. Editor-safe. */
(function () {
  var instances = new WeakMap();
  var LEAN = [-1, 0.8, -0.55, 0.95, -0.75, 0.6]; /* uneven, so it never reads as a pattern */
  var STEP = 140, MAX_STEPS = 4;                 /* stagger: at most 4 steps per batch */
  var CLOSE_MS = 220; /* the text fades out in 0.2 s (.ing__more transition in the CSS) */
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* From DOM order, never :nth-child: Shopify may wrap blocks. */
  function lean(root) {
    var tilt = parseFloat(root.getAttribute('data-tilt') || '0') || 0;
    root.querySelectorAll('[data-ing-entry]').forEach(function (el, i) {
      el.style.setProperty('--ing-tilt', (LEAN[i % LEAN.length] * tilt).toFixed(2) + 'deg');
      el.classList.toggle('ing__item--even', i % 2 === 1); /* rows layout: alternate sides by real order */
    });
  }


  /* Safety net for titles on narrow screens: words are never split (CSS), so if the longest
     word is still wider than the panel, shrink that title just enough. Re-measured on resize. */
  function fitTitles(scope, selector) {
    scope.querySelectorAll(selector).forEach(function (el) {
      el.style.removeProperty('font-size');
      var avail = el.clientWidth;
      if (!avail) return;
      var size = parseFloat(getComputedStyle(el).fontSize);
      for (var i = 0; i < 12 && el.scrollWidth > avail + 1 && size > 14; i++) {
        size = Math.max(14, size * Math.max(0.8, (avail / el.scrollWidth) * 0.98));
        el.style.setProperty('font-size', size + 'px', 'important');
      }
    });
  }
  function watchTitles(scope, selector) {
    var run = function () { fitTitles(scope, selector); };
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 150); });
  }

  function showAll(items) {
    items.forEach(function (el) { el.classList.add('is-in'); el.classList.remove('is-out'); });
  }

  /* Words stay whole: a heading whose longest word is wider than its line shrinks in 5% steps
     (down to 50%) until every word fits. Breaking after a hyphen stays allowed (a normal line
     break); breaking inside a word does not (the CSS sets that). Font size, so lines reflow. */
  function fitWholeWords(els) {
    els.forEach(function (el) {
      el.style.fontSize = '';
      if (!el.clientWidth || el.scrollWidth <= el.clientWidth + 1) return;
      var base = parseFloat(getComputedStyle(el).fontSize) || 16;
      for (var k = 0.95; k >= 0.5; k -= 0.05) {
        el.style.fontSize = (base * k).toFixed(1) + 'px';
        if (el.scrollWidth <= el.clientWidth + 1) break;
      }
    });
  }
  function watchWholeWords(getEls) {
    var run = function () { fitWholeWords(getEls()); };
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    var lastW = window.innerWidth, t;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return; // width changes only (a phone's bars change the height)
      lastW = window.innerWidth; clearTimeout(t); t = setTimeout(run, 150);
    });
  }

  function mount(root) {
    if (instances.has(root)) return;
    watchWholeWords(function () { return [].slice.call(root.querySelectorAll('[data-ing-entry] :is(h1, h2, h3, h4)')).filter(function (h) { return !h.closest('details, .ing__more'); }); });
    var items = [].slice.call(root.querySelectorAll('[data-ing-title], [data-ing-entry]'));
    var motion = root.getAttribute('data-motion') || 'both';
    var timers = new Map();
    var closing = new Map();
    var io = null;

    lean(root);
    watchTitles(root, '[data-ing-title] :is(.text-block, h1, h2, h3, h4, h5, h6, p):not(:has(:is(h1, h2, h3, h4, h5, h6, p)))');
    /* The ready attribute arms the hidden start state, so a JS failure leaves content visible. */
    root.setAttribute('data-ing-ready', '');

    /* Only grid cards float their text; the rows layout keeps Savor's normal accordion. */
    function floating(d) { return !!d && d.tagName === 'DETAILS' && root.contains(d) && !!d.closest('.ing__list--grid'); }

    function finishClose(d) {
      clearTimeout(closing.get(d));
      closing.delete(d);
      d.classList.remove('is-closing');
      d.open = false;
    }
    /* The text is shown inside the photo frame (.ing__more), not floated through <details>. */
    function frameOf(d) { var it = d.closest('[data-ing-entry]'); return it && it.querySelector('.ing__itemmedia'); }
    /* The text layer is in every frame from the start (empty, invisible), so opening can fade it
       in the same frame. Only the text moves in and out: the <style> tags Savor's text blocks
       carry stay put (moving a <style> element re-adds a stylesheet: the whole page restyled
       on every click). */
    function layerOf(media) {
      var more = media.querySelector('.ing__more');
      if (!more) { more = document.createElement('div'); more.className = 'ing__more'; media.appendChild(more); }
      return more;
    }
    root.querySelectorAll('.ing__list--grid .ing__itemmedia').forEach(layerOf);
    function showText(d) {
      var media = frameOf(d), src = d.querySelector('.details-content');
      if (!media || !src) return;
      var more = layerOf(media);
      Array.prototype.slice.call(src.childNodes).forEach(function (n) { if (n.nodeName !== 'STYLE') more.appendChild(n); });
      more.scrollTop = 0;
      media.classList.add('is-text');
    }
    function hideText(d) {
      var media = frameOf(d), src = d.querySelector('.details-content'), more = media && media.querySelector('.ing__more');
      if (media) media.classList.remove('is-text');
      if (more && src) while (more.firstChild) src.appendChild(more.firstChild);
    }
    function onToggle(e) {
      var d = e.target;
      if (!floating(d)) return;
      if (d.open) showText(d); else hideText(d);
    }
    root.addEventListener('toggle', onToggle, true); /* toggle doesn't bubble: capture */
    root.querySelectorAll('.ing__list--grid details[open]').forEach(showText); /* "open by default" */

    function closeText(d) {
      if (!d.open || closing.has(d)) return;
      var m = frameOf(d); if (m) m.classList.remove('is-text'); /* fade the text out first */
      if (reduceMQ.matches) { d.open = false; return; }
      d.classList.add('is-closing'); /* still [open], so the text keeps floating while it fades */
      closing.set(d, setTimeout(function () { finishClose(d); }, CLOSE_MS));
    }

    function onClick(e) {
      var s = e.target.closest && e.target.closest('summary');
      var d = s && s.parentElement;
      if (!floating(d)) return;
      if (d.open) { e.preventDefault(); closeText(d); } /* also swallows clicks mid-fade */
    }
    function onKey(e) {
      if (e.key !== 'Escape') return;
      var d = e.target.closest && e.target.closest('details[open]');
      if (!d || !root.contains(d)) return;
      var s = d.querySelector('summary');
      if (floating(d)) closeText(d); else d.open = false;
      if (s) s.focus();
    }
    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKey);

    function stopMotion() {
      if (io) { io.disconnect(); io = null; }
      timers.forEach(clearTimeout); timers.clear();
      showAll(items);
    }

    if (motion === 'none' || reduceMQ.matches || !('IntersectionObserver' in window)) {
      showAll(items);
    } else {
      io = new IntersectionObserver(function (entries) {
        var n = 0;
        entries.forEach(function (e) {
          var el = e.target;
          if (e.isIntersecting) {
            el.classList.remove('is-out');
            if (el.classList.contains('is-in')) return;
            var d = Math.min(n++, MAX_STEPS) * STEP;
            el.style.setProperty('--ing-d', d + 'ms');
            el.classList.add('is-in');
            clearTimeout(timers.get(el));
            /* Drop the stagger once landed, so hover responds instantly. */
            timers.set(el, setTimeout(function () { el.style.removeProperty('--ing-d'); timers.delete(el); }, d + 1300));
          } else if (motion === 'both' && el.classList.contains('is-in') && !el.querySelector('details[open]')) {
            el.classList.add('is-out');
          }
        });
      }, { rootMargin: '-4% 0px -6% 0px', threshold: 0.06 });
      items.forEach(function (el) { io.observe(el); });
    }

    /* The visitor turns on reduced motion while the page is open: show everything, stop observing. */
    function onReduce() { if (reduceMQ.matches) stopMotion(); }
    if (reduceMQ.addEventListener) reduceMQ.addEventListener('change', onReduce);

    instances.set(root, {
      destroy: function () {
        stopMotion();
        closing.forEach(function (t, d) { finishClose(d); });
        root.removeEventListener('click', onClick);
        root.removeEventListener('keydown', onKey);
        root.removeEventListener('toggle', onToggle, true);
        if (reduceMQ.removeEventListener) reduceMQ.removeEventListener('change', onReduce);
      }
    });
  }

  function unmount(root) {
    var inst = instances.get(root);
    if (!inst) return;
    inst.destroy();
    instances.delete(root);
  }
  function mountAll(scope) { (scope || document).querySelectorAll('[data-ing]').forEach(mount); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountAll(); });
  else mountAll();
  document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { e.target.querySelectorAll('[data-ing]').forEach(unmount); });
  /* Editor: a selected block is always shown, and a drag may have changed the order. */
  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target.closest) return;
    var el = e.target.closest('[data-ing-title], [data-ing-entry]');
    if (el) { el.classList.add('is-in'); el.classList.remove('is-out'); }
    var root = e.target.closest('[data-ing]');
    if (root) lean(root);
  });
})();
